import { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Button, SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row, Spinner } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import { RiEditFill } from "react-icons/ri";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import EditBannerModal from "../../Components/Modals/EditBannerModal.js";
import { useDeleteCategoryMutation } from "../../Data/services/categoryApi.js";
import {
  useDeleteBannerMutation,
  useGetAllBannerQuery,
  useUpdateBannerMutation,
} from "../../Data/services/bannerApi.js";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import { useGetAllProductQuery } from "../../Data/services/productApi.js";
import SelectFieldComponent from "../../Components/CustomComponents/SelectFieldComponent.js";
// import { useDeleteBusinessTypeMutation, useGetAllBusinessTypeMutation, useGetAllBusinessTypeQuery } from "../../Data/services/businessTypeApi.js";
// import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
// const CustomerBlockModal = lazy(() =>
//   import("../../Components/Modals/CustomerBlockModal.js")
// );

const BannerManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  // const dummyData = [
  //   {
  //     id: 4,
  //     title: "Lorem Ipsum",
  //     description: "lorem ipsum",
  //     image_url: "https://picsum.photos/id/1/200/300",
  //     product_id: 8,
  //     status: 1,
  //     createdAt: "2025-06-03T11:56:32.000Z",
  //     updatedAt: "2025-06-03T11:56:32.000Z",
  //   },
  //   {
  //     id: 3,
  //     title: "The Fries Wala",
  //     description:
  //       "Design food ,drink product banner, and restaurant banners by Arso",
  //     image_url:
  //       "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1-CGWiYieTq_pu2VMitCvc755LIa3M26osw&s",
  //     product_id: 1,
  //     status: 1,
  //     createdAt: "2025-05-12T15:36:01.000Z",
  //     updatedAt: "2025-05-12T15:36:01.000Z",
  //   },
  //   {
  //     id: 2,
  //     title: "Arso Top Shop",
  //     description:
  //       "134+ Thousand Women Clothing Banner Royalty-Free Images, Stock Photos & Pictures",
  //     image_url:
  //       "https://www.shutterstock.com/image-photo/women-fashion-clothes-accessories-banner-260nw-1745982053.jpg",
  //     product_id: 2,
  //     status: 1,
  //     createdAt: "2025-05-12T15:34:16.000Z",
  //     updatedAt: "2025-05-12T15:34:16.000Z",
  //   },
  //   {
  //     id: 1,
  //     title: "Painted Clothes",
  //     description: "Free custom, printable clothing banner templates",
  //     image_url:
  //       "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYQvGCRHl5QWS__QcBa270Cb4zY80B3Fmbeg&s",
  //     product_id: 3,
  //     status: 1,
  //     createdAt: "2025-05-12T15:30:22.000Z",
  //     updatedAt: "2025-05-12T15:30:22.000Z",
  //   },
  // ];

  const { data: productData, isLoading: productLoading } =
    useGetAllProductQuery(
      {
        is_paginate: false,
      },
      { refetchOnMountOrArgChange: true }
    );
  // console.log(productData);

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllBannerQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);

      if (data.data.length === 0) {
        setIndicationMessage("Data not available");
      }
    }
  }, [data]);

  const [selectedType, setSelectedType] = useState("");

  const [update, { isLoading: updating }] = useUpdateBannerMutation();

  const handleDynamicTypeChange = async (value, row) => {
    console.log(value);
    console.log(row);
    setSelectedType(value);

    const data = {
      title: row.title,
      description: row.description,
      image_url: row.image_url,
      product_id: value,
    };

    try {
      const response = await update({
        data: data,
        id: row.id,
      }).unwrap();
      console.log(response);

      if (response.code === 200) {
        refetch();
        SuccessToast(response?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  // const debouncedSearch = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [item.firstname, item.lastname, item.username, item.email]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [deleteBanner, { isLoading: isDeleting }] = useDeleteBannerMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deleteBanner(slug);
      // console.log(data);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "title",
      text: "Title",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
    },
    {
      dataField: "image_url",
      text: "Image",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        // return row.firstname + row.lastname;
        return (
          <img
            alt="user"
            src={cellContent || "images/no_image_available.png"}
            loading="lazy"
            width={62}
            height={62}
            className="rounded-circle object-fit-cover"
          />
        );
      },
    },
    {
      dataField: "description",
      text: "Description",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        return (
          <span className="lc-2">
            {cellContent ? cellContent : "No description available"}
          </span>
        );
      },
    },
    {
      dataField: "product_id",
      text: "Product",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        const product = productData.find((item) => item.value === cellContent);
        // return <span className="lc-2">{product?.label || "No Product"}</span>;
        return (
          <SelectFieldComponent
            classes={`m-0 py-2 border-0 pointer hover-border bg-secondary-subtle`}
            firstOption={product?.label}
            optionsList={productData ? productData : []}
            onSelectChange={(value) => handleDynamicTypeChange(value, row)}
          />
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        // width: "100px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug || row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <ToolTip placement={"top"} content={"Edit Category"}>
                <div
                  className={` d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2 `}
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleEditModalOpen(true);
                  }}
                >
                  <span
                    className={`align-items-center d-flex justify-content-center `}
                  >
                    <RiEditFill />
                  </span>
                  {/* <span>Edit</span> */}
                </div>
              </ToolTip>

              <ToolTip placement={"top"} content={"Delete Category"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-danger-hover rounded-3 p-2 mx-2 "
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleDeleteModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center`}>
                    <MdDeleteForever />
                  </span>
                  {/* <span>Delete</span> */}
                </div>
              </ToolTip>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditBannerModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            productData={productData || []}
            refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Banner Management"} classes="text-black" />
        </div>

        {
          <Row>
            <Col md={12}>
              <Button
                classes={`${styles.cardBtn} `}
                text="Add Banner"
                onClick={handleAddUser}
              ></Button>
            </Col>
          </Row>
        }
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || isLoading || productLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                refetch={refetch} // todo
                // refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default BannerManagementScreen;
